import { Outlet } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import { TopBar } from "./TopBar";
import { SiteFooter } from "@/components/SiteFooter";

const ChatLauncher = lazy(() =>
  import("@/components/chat/ChatLauncher").then((m) => ({ default: m.ChatLauncher }))
);

export function AppShell() {
  const [showChat, setShowChat] = useState(false);
  useEffect(() => {
    const w = window as unknown as { requestIdleCallback?: (cb: () => void) => number };
    const schedule = w.requestIdleCallback ?? ((cb: () => void) => window.setTimeout(cb, 1500));
    const id = schedule(() => setShowChat(true));
    return () => {
      const cancel = (window as unknown as { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback;
      if (cancel) cancel(id as number);
      else window.clearTimeout(id as number);
    };
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <TopBar />
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>
      <SiteFooter />
      {showChat && (
        <Suspense fallback={null}>
          <ChatLauncher />
        </Suspense>
      )}
    </div>
  );
}
